/**
 * Класс сервер получает данные с сервера и
 * кидает евенты при соответствующих результатах с сервера
 */
/* global DEBUG */

$.support.cors = true
var server = ''

export default class Server {

  constructor(model, type = 'GET') {
    this.model = model
    this.type = type
  }

  fetch({headers: headers}) {
    var model = this.model

    // перед запросом установим алерт
    model.$broadcast('alert', {
      name: model.name, type: 'server.wait', view: true
    })

    if ( model.data && model.data.constructor.name == 'FormData' ) {
      var contentType = false
      var processData = false
    } else {
      var contentType = (this.type == 'GET')
        ? 'application/json' : 'application/x-www-form-urlencoded'
      var processData = true
    }

    return $.ajax({
      url: server + model.url,
      data: model.data,
      type: this.type,
      // crossDomain: true,
      dataType: 'json',
      processData: processData,
      contentType: contentType,
      headers: headers,
    })
    .done( response => {
      //DEBUG && console.log( 'fetch ok =', response)
      // при успешном запросе удалим алерт
      model.$broadcast('alert', {
        name: model.name, type: 'server.wait', view: false
      })
      model.$set('data', response)
      if (model.$get('data.errors') !== undefined){
        //DEBUG && console.log(model.$get('data.errors'))
          model.$parent && model.$broadcast('alert', {
              name: model.name, type: 'form.error', view: true
          })
      }else {
          model.$parent && model.$broadcast('alert', {
              name: model.name, type: 'form.error', view: false
      })
      }
      // рапортуем что все ок
      model.$parent && model.$parent.$broadcast('fetchData:ok')
    })
    .fail( xhr => {
     //DEBUG && console.log('fetch failed =', xhr.responseJSON, xhr.responseText )
      // при неудачном запросе - алерт error
      model.$parent && model.$broadcast('alert', {
        name: model.name, type: 'server.error', view: true
      })
      model.data = xhr.responseJSON
      // рапортуем что error
      model.$parent && model.$parent.$broadcast('fetchData:error')
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/Server.js
 **/